// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    cryptoJS: {
        base64Key: '0123456789abcdef0123456789abcdef',
        iv: 'abcdef9876543210abcdef9876543210',
    },
    baseUrl: 'https://internaldev.sigsense.tech',
    recaptchaKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    customerApiUrl: 'https://internalapi.sigsense.tech/v4',
    configcat: {
        enabled: false,
        key: 'VV7ZCLFnuU2Axjy2xwhqcA/AmlByf4owkyHaoV0fHYWqA',
    },
    labels: {
        trainingSession: 1,
        validationSession: 2,
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
